// Farbtöne für Chips, Pillen, KPI-Kacheln. Nur Tokens aus README §4 – keine eigenen Farben.

export type Ton = 'neutral' | 'acc' | 'ok' | 'warn' | 'bad' | 'info' | 'glas';

export interface TonFarben {
  /** Hintergrund (weiche Fläche) */
  bg: string;
  /** Vordergrund (Text/Icon) */
  fg: string;
}

const TOENE: Record<Ton, TonFarben> = {
  neutral: { bg: 'var(--fill2)', fg: 'var(--ink2)' },
  acc: { bg: 'var(--acc-soft)', fg: 'var(--acc)' },
  ok: { bg: 'var(--ok-soft)', fg: 'var(--ok)' },
  warn: { bg: 'var(--warn-soft)', fg: 'var(--warn)' },
  bad: { bg: 'var(--bad-soft)', fg: 'var(--bad)' },
  info: { bg: 'var(--info-soft)', fg: 'var(--info)' },
  // Chips auf Fotos (Objektnummer auf der Kachel)
  glas: { bg: 'var(--chip)', fg: 'var(--chip-ink)' },
};

export function tonFarben(ton: Ton): TonFarben {
  return TOENE[ton];
}
